import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { getSafeURL } from './utils';
import { getResourceTo } from 'react/utils/utils';
import { usePin } from 'react/hooks/sidebar.hook';

function SingleMenuItem({ external, url, name }) {
  const { pinMenu, isPinned, canPinMenus } = usePin();

  function handlePinMenu() {
    const menu = {
      name,
      url,
      external
    };

    pinMenu(menu);
  }

  const isThisMenuPinned = useMemo(() => isPinned({
    name,
    url,
  }), [isPinned]);

  const singleMenuClassName = useMemo(() => {
    if (isThisMenuPinned) {
      return 'pin-icon active';
    } else if (canPinMenus) {
      return 'pin-icon';
    }

    return 'pin-icon cant-pin';
  }, [isThisMenuPinned, canPinMenus, name, url]);

  const iconTitle = useMemo(
    () => {
      if (isThisMenuPinned) {
        return getResourceTo('sidebar.unPinMenu.tooltip')
      }

      return canPinMenus ?
        getResourceTo('sidebar.canPinMenu.tooltip') :
        getResourceTo('sidebar.canNotPinMenu.tooltip');
    },
    [canPinMenus, isThisMenuPinned]
  );

  return (
    <li>
      {
        external
          ? (
            <a href={`${url}`} target="_blank" rel="noopener noreferrer">
              <span>{getResourceTo(name)}</span>
            </a>
          )
          : (
            <>
              <Link
                to={`${getSafeURL(url)}`}
                data-testid={`${name}-submenu`}
                title={getResourceTo(name)}
              >
                {getResourceTo(name)}
              </Link>
              <span
                onClick={handlePinMenu}
                className={singleMenuClassName}
                alt="Pin Icon"
                data-testid={`${name}-pin-icon`}
                title={iconTitle}
              />
            </>
          )
      }
    </li>
  );
}

SingleMenuItem.propTypes = {
  url: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  external: PropTypes.bool
};

SingleMenuItem.defaultProps = {
  external: false
};

export default memo(SingleMenuItem);
